<template>
  <v-sheet class="base-layout">
    <slot />
  </v-sheet>
</template>

<script>
export default {
  name: "p-base",
};
</script>

<style scoped>
.base-layout {  
  width: 100vw;
  min-height: calc(100vh - 124px);

  display: flex;
  flex-direction: column;

  align-items: center;

  padding: 20px;
}
</style>
